'use client';
import { createProps, createSplitProps } from '@chakra-ui/utils';

const tabsProps = createProps()([
  "defaultIndex",
  "direction",
  "id",
  "index",
  "isLazy",
  "isManual",
  "lazyBehavior",
  "onChange",
  "orientation",
  "orientation"
]);
const splitTabsProps = createSplitProps(tabsProps);

export { splitTabsProps, tabsProps };
